import React from "react";

const AnalysisResult = ({
  analysisResult,
  analysisOrder,
  mapConsoleLabels,
  mapConsoleValues,
  isOrange,
}) => {
  return (
    <div className="mt-8 analysis-result">
      <p
        style={{ fontFamily: "Red Hat Display" }}
        className="text-xl font-bold orange"
      >
        CONSOLE Score
      </p>
      <div className="grid grid-cols-1 gap-12 mt-8 md:grid-cols-2">
        <div className="px-8 py-6 bg-white border-2 border-gray-100 rounded-lg shadow-sm">
          <div className="flex flex-row justify-center lg:gap-8 md:gap-6 sm:gap-6">
            {mapConsoleLabels().map((label, index) => (
              <div key={index} className="flex flex-col items-center gap-2">
                <p
                  className={`lg:text-4xl md:text-xl sm:text-xl font-bold ${isOrange(
                    mapConsoleValues(analysisResult[0].numericValues)[index]
                  )}`}
                >
                  {label}
                </p>
                <p
                  className={`text-4xl md:text-xl sm:text-xl ${isOrange(
                    mapConsoleValues(analysisResult[0].numericValues)[index]
                  )}`}
                >
                  {mapConsoleValues(analysisResult[0].numericValues)[index]}
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className="flex items-center justify-center px-8 py-6 rounded-lg shadow-sm bg-light-orange">
          <div className="flex flex-row items-center justify-center gap-8">
            <p className="font-bold orange lg:text-xl md:text-lg sm:text-base lg:w-48 md:w-40 sm:w-36">
              Aggregate CONSOLE Score:
            </p>
            <p className="font-bold orange lg:text-6xl md:text-4xl sm:text-4xl">
              {analysisResult[0].score}
            </p>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-12 mt-8 md:grid-cols-2">
        {analysisOrder.map((key) => (
          <div
            key={key}
            className="px-8 py-6 bg-white border-2 border-gray-100 rounded-lg shadow-sm"
          >
            <div className="">
              <div className="flex flex-row items-center justify-between">
                <div
                  style={{ fontFamily: "Red Hat Display" }}
                  className="text-lg"
                >
                  {key}
                </div>
                <div
                  style={{ fontFamily: "Red Hat Display" }}
                  className="text-lg orange"
                >
                  {analysisResult[0].numericValues[key]}
                </div>
              </div>
              <p className="mt-2 text-base">
                {analysisResult[0].textValues[key]}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AnalysisResult;
